import React, { useState } from "react";
import formatDate from "../../../util/formatDate";
import cn from "classnames";
import styles from "./Day.module.scss";
import dayjs from "dayjs";
import classNames from "classnames";
const Day = ({ isToday, isDisabled, isSelected, isBooked, isFocused, className, date, onClick, ...rest }) => {
    const [animate, setAnimate] = useState(false);
    const _classname = cn("calendar__day", "typography-main", styles.root, {
        [styles.selected]: isSelected,
        [styles.today]: isToday,
        [styles.disabled]: isDisabled,
        [styles.booked]: isBooked,
        [styles.focused]: isFocused,
    }, className);
    const handleClick = React.useCallback((e) => {
        if (isDisabled) {
            e.stopPropagation();
            e.preventDefault();
            return;
        }
        onClick && onClick(date);
        setAnimate(true);
    }, [onClick, date, isDisabled]);
    return (React.createElement("button", { title: formatDate(date), onClick: handleClick, className: _classname, "aria-label": dayjs(date).format("D MMMM YY"), disabled: isDisabled, ...rest },
        React.createElement("span", { onAnimationEnd: () => setAnimate(false), className: classNames(animate ? styles.pulse : undefined) }, dayjs(date).format("D"))));
};
export default Day;
//# sourceMappingURL=Day.js.map